module.exports = __webpack_public_path__ + "static/img/post_2.0f3da35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_2.png
// module id = 5B6s
// module chunks = 0